<script>
import compoment from '@/components/draggable/CustomComponents/Radio/DRadioEditor'
export default {
  name: 'DBrowseSettingEditor',
  extends: compoment
}
</script>
